import React, { Fragment } from "react"
import clsx from "clsx"
import { FaTimes } from "react-icons/fa"

import { getMoment } from "utils"
import classes from "./DpMonths.module.scss"

const monthsName = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"]

const moment = getMoment()

const DpMonths = props => {
  const {
    minDate,
    maxDate,
    shownDate,
    setShownDate,
    setContent
  } = props

  const handleClick = monthIndex => {
    const newDate = moment(shownDate)
    newDate.jMonth(monthIndex)

    setShownDate(newDate)
    setContent("days")
  }

  const handleClose = () => {
    setContent("days")
  }

  return (
    <Fragment>
      <button
        onClick={handleClose}
        className={classes["close-button"]}
      >
        <FaTimes className="fa fa-close" />
      </button>
      <div className={classes["month-container"]}>
        <div className={classes["month"]}>
          {monthsName.map((monthName, i) => {
            const month = moment(shownDate)
            month.jMonth(i)
              .startOf("jMonth")
              .hour(0)
              .minute(0)
              .second(0)
              .millisecond(0)

            const max = moment(maxDate)
            max.startOf("jMonth")
              .hour(0)
              .minute(0)
              .second(0)
              .millisecond(0)

            const min = moment(minDate)
            min.startOf("jMonth")
              .hour(0)
              .minute(0)
              .second(0)
              .millisecond(0)

            const isDisabled =
              (!!maxDate && month.isAfter(max)) ||
              (!!minDate && month.isBefore(min))

            return (
              <button
                key={monthName}
                disabled={isDisabled}
                onClick={() => handleClick(i)}
                className={clsx(classes["month-name"],
                  monthsName[shownDate.jMonth()] === monthName &&
                  classes["active"]
                )}
              >
                {monthName}
              </button>
            )
          })}
        </div>
      </div>
    </Fragment>
  )
}

export default DpMonths